<template functional>
  <div
    class="top-alert-box top-alert-box-primary top-alert-box--solid-bg p-l-20 p-r-20 slide-down slide-down--medium-duration"
    :class="props.customClass"
  >
    <div class="top-alert-box__message text-left">
      <div class="top-alert-box__title">
        {{ props.primaryMessage }}
        <span class="top-alert-box__title-sup">
          {{ props.superScript }}
        </span>
      </div>

      <span class="top-alert-box__sub-title">
        {{ props.subMessage }}
      </span>
    </div>

    <button
      class="btn btn-secondary m-l-40"
      :class="props.customButtonClass"
      @click="props.openPage"
    >
      Get Started
    </button>

    <span
      class="top-alert-box__close"
      @click="props.closeBanner()"
    >
      <i class="fa fa-times" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'NewFeatureBanner',
  props: {
    primaryMessage: {
      type: String,
      required: true
    },
    subMessage: {
      type: String,
      default: ''
    },
    superScript: {
      type: String,
      default: ''
    },
    closeBanner: {
      type: Function,
      required: true
    },
    openPage: {
      type: Function,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    },
    customButtonClass: {
      type: String,
      default: ''
    }
  },
};
</script>

<style>

</style>